import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';

export class SolicitudSeguimientoExViewModel {
    public Id: number;
    public IdEstadoSolicitudEx: number;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPrevia: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
    public TComentarioInspectorExCollection: TComentarioInspectorExViewModel[];

    public THistorialReasignacionPcfExCollection: THistorialReasignacionPcfExViewModel[];
}

export class TComentarioInspectorExViewModel {
    public IdSolicitudEx: number;
    public IdEstadoSolicitudEx: number;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdTipoSolicitudExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    public EsPrevia: boolean;
    public Id: number;
    public IdInspector: number;
    public Inspector = '';
    public Fecha: Date;
    public Observaciones = '';
    public IdSeccion: number;
    public IdMotivo: number;
    public IdSeccionDescripcion: string;
    public IdMotivoDescripcion: string;
    public VisibleSolicitante: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}

export class THistorialReasignacionPcfExViewModel {
    public NombrePuntoInspeccion: string;
    public ModoReasignacion: string;
    public FechaCambioPcf: Date | null;
}
